import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertCircleIcon, Loader2Icon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
export function AdminLogin() {
  const {
    loggedIn,
    authLoading,
    login
  } = useAdminData();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [errorCode, setErrorCode] = useState('');
  const [loading, setLoading] = useState(false);

  // Mens Firebase undersøger, om der allerede findes en gemt session,
  // vises en indlæsningstilstand — ikke login-formularen.
  if (authLoading) {
    return <div className="flex min-h-screen w-full items-center justify-center bg-canvas px-5" data-id="element-501" data-mp="1pu7189pdkdnm">
        <p className="flex items-center gap-2 text-[15px] text-ink-muted" data-id="element-502" data-mp="1woewrc9kjpqn">
          <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-503" data-mp="20pgvlrzkpzs3" />
          Henter …
        </p>
      </div>;
  }
  if (loggedIn) return <Navigate to="/admin" replace data-id="element-504" data-mp="25pv6riwh1puc" />;
  return <div className="flex min-h-screen w-full items-center bg-canvas px-5 py-12" data-id="element-505" data-mp="2anmxwapal7xh">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto w-full max-w-sm" data-id="element-506" data-mp="2alk91tzvlkuc">
        <img src={company.logoWide} alt="LYKKEVÆRK" className="h-14 w-auto" data-id="element-507" data-mp="1hwmvg46m0c7x" />
        <h1 className="mt-4 font-display text-xl font-semibold tracking-tight text-ink-soft" data-id="element-508" data-mp="1mwr79gwkoirt">Admin</h1>

        <form className="mt-8 rounded-card border border-line bg-white p-6 md:p-8" onSubmit={async event => {
        event.preventDefault();
        if (loading) return;
        setLoading(true);
        const result = await login(email, password);
        if (!result.ok) {
          setError(result.error ?? 'Der opstod en fejl. Prøv igen.');
          setErrorCode(result.code ?? '');
          setPassword('');
          setLoading(false);
          return;
        }
        setError('');
        setErrorCode('');
        navigate('/admin');
      }} data-id="element-509" data-mp="1rqvhc914x6x4">
          <TextField id="admin-mail" label="E-mail" type="email" required autoComplete="off" value={email} onChange={event => {
          setEmail(event.target.value);
          if (error) {
            setError('');
            setErrorCode('');
          }
        }} data-id="element-510" data-mp="88eb7ykfmcjk" />
          <TextField id="admin-kode" label="Password" type="password" required autoComplete="current-password" className="mt-5" value={password} onChange={event => {
          setPassword(event.target.value);
          if (error) {
            setError('');
            setErrorCode('');
          }
        }} data-id="element-511" data-mp="1tm0mfdfjp8cz" />

          {error && <div role="alert" className="mt-4 rounded-xl bg-danger/10 px-4 py-3 text-sm text-danger" data-id="element-512" data-mp="2xm7c6fj2kiob">
              <p className="flex items-start gap-2" data-id="element-513" data-mp="3q89zhx6n5c9e">
                <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-514" data-mp="3qawgsojc364t" />
                {error}
              </p>
              {errorCode && <p className="mt-1.5 pl-6 font-mono text-xs text-danger/80" data-id="element-515" data-mp="3ghxhabmatv6f">{errorCode}</p>}
            </div>}

          <Button type="submit" size="lg" className="mt-7 w-full" disabled={loading || authLoading} data-id="element-516" data-mp="3lfyx8nofhedo">
            {loading ? <>
                <Loader2Icon className="h-5 w-5 animate-spin" aria-hidden="true" data-id="element-517" data-mp="ht8d0oq9dqgi" />
                Logger ind …
              </> : 'Log ind'}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-ink-muted" data-id="element-518" data-mp="2kcf5eetffn1f">
          <Link to="/" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-519" data-mp="2gblj1pvmugan">
            Tilbage til hjemmesiden
          </Link>
        </p>
      </motion.div>
    </div>;
}